import { IconProps } from '@shared/interfaces/icon.interface';
import * as React from 'react';

export const FishIcon: React.FC<IconProps> = ({ width = 28, height = 28, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width={width} height={height} className={className}>
    <path
      fill="#3B88C3"
      d="M32.153 24c0-1 1.523-6.212 3.047-7.735 1.522-1.523 0-3.166-1.523-3.166-3.405 0-9.139 6.901-9.139 10.901 0 5 5.733 10.424 9.139 10.424 1.523 0 3.046-1.404 1.523-2.928C33.677 29.974 32.153 26 32.153 24z"
    />
    <path
      fill="#3B88C3"
      d="M9.021 14.384c0-3.046 1.497-6.093 3.02-6.093 4.569 0 13.322 4.823 14.845 12.439 1.524 7.616-17.865-6.346-17.865-6.346zm4.854 18.278c1.523 1.523 4.57 3.047 7.617 3.047 3.046 0-3.111-4.189-1.523-6.092 2.18-2.617-6.094 3.045-6.094 3.045z"
    />
    <path d="M2.071 28.727c.761-2.285.19-3.935-1.143-5.584-1.333-1.651 3.872-1.904 5.585.381s5.713 6.281 2.158 6.22c-3.553-.065-6.6-1.017-6.6-1.017z" />
    <path
      fill="#55ACEE"
      d="M.168 23.488c.959.874 7.223 4.309 7.165 5.137-.058.828-2.279-.088-3.105-.279-1.485-.342-1.905-.598-2.317-.526-.84.321-.554 1.201-.242 1.704 1.498 2.61 7.286 4.662 12.16 4.662 8.412 0 16.802-7.615 16.802-10.662 0-3.046-9.345-10.663-17.757-10.663C4.483 12.86.18 18.922.168 23.488z"
    />
    <path d="M7 17a2 2 0 1 1 .001 3.999A2 2 0 0 1 7 17z" />
    <path
      fill="#269"
      d="M15.08 29.98a.997.997 0 0 1-.885-1.463c1.585-3.034 2.218-5.768.154-9.243a1 1 0 0 1 1.72-1.022c2.693 4.535 1.46 8.202-.102 11.191a.999.999 0 0 1-.887.537z"
    />
  </svg>
);

export default FishIcon;
